import React from 'react'

import Item from './item/Item'
import { ListOffer } from 'dealer-types'
import { ItemProvider } from 'src/contexts/itemContext'

const LikeItem = (props: ListOffer): JSX.Element => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
    // @ts-ignore
    <ItemProvider {...props}>
      <Item />
    </ItemProvider>
  )
}

export default LikeItem
